import { bridge } from "#/shared/constants"
import { BridgeAssetFormValue } from "#/shared/types"

import { useStepperModalContext } from "../StepperModal"
import { ComponentStepProps } from "../StepperModal/StepperModal"

import BridgeBTC from "./BridgeBTC"
import BridgeDeposit from "./BridgeDeposit"
import BridgeERC20 from "./BridgeERC20"

export default function BridgeReviewStep(props: ComponentStepProps) {
  const {
    values: { token, depositId, amount },
  } = useStepperModalContext<BridgeAssetFormValue>()

  if (depositId) {
    const { sourceToken } = bridge.BRIDGEABLE_TOKENS[token]
    return (
      <BridgeDeposit
        {...props}
        amount={amount!}
        depositId={depositId}
        tokenAddress={sourceToken}
      />
    )
  }

  if (token === "BTC") return <BridgeBTC {...props} />

  return <BridgeERC20 {...props} />
}
